/**
 * Created by mark on 11/12/2017.
 */



import React  from 'react';
import {ProgressBar , Form , Button , Card} from 'react-bootstrap'
import AuthenticationService from '../services/authenticate-service.js';
import ProductStore from '../store/product-store.js';
import ClassesStore from '../store/classes-store.js'
import ClassesService from '../services/classes-service.js'
export default class Authentication extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            username:"",
            password:"",
            secret:''
        };
    }

    componentDidMount(){
        if (this.props.match.params.token != undefined) {
            sessionStorage.setItem('USER_TOKEN', this.props.match.params.token);
            ClassesService.getStudentsAll().then(function(response){
                if (response != null && response.length > 0) {
                    window.location.hash = 'examTests/list'
                } else {
                    window.location.hash = 'videos/helpVideos'
                }
            })
        }
        ProductStore.languages = [];
        ClassesStore.classes = {};
        ClassesStore.students = [];
        ClassesStore.list = [];
        ClassesStore.lastClass = [];
        ClassesStore.classList = [];
    }

    authentication(){
        this.setState({
           loading:true,
        });

        AuthenticationService.authenticate(this.state.username , this.state.password).then(function(response){
            if (response != undefined && response != "") {    
                ClassesService.getStudentsAll().then(function(response){
                        if (response != null && response.length > 0) {
                            window.location.hash = 'examTests/list'
                        } else {
                            window.location.hash = 'videos/helpVideos'
                        }
                })
            } else {
                this.setState({
                    loading:false,
                 });
            }
        }.bind(this));
    }


    render(){


        if(this.state.loading) return <ProgressBar animated now={45} />;


        return <div className="row">
            <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
                <Card className="my-5">
                    <Card.Body>
                        <Form>
                            <Form.Group controlId="formBasicEmail">
                                <Form.Label>Username</Form.Label>
                                <Form.Control type="text" placeholder="Enter username"
                                              value={this.state.username}
                                              onChange={(e)=>{ this.setState({username:e.target.value})}}

                                    />
                            </Form.Group>

                            <Form.Group controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder="Password"   value={this.state.password}
                                              onChange={(e)=>{ this.setState({password:e.target.value})}}/>
                            </Form.Group>
                            <Button onClick={this.authentication.bind(this)} variant="primary" >
                                Submit
                            </Button>
                        </Form></Card.Body></Card></div>
        </div>

    }

}